import { render, staticRenderFns } from "./OrderAudit.vue?vue&type=template&id=8534df64&scoped=true"
import script from "./OrderAudit.vue?vue&type=script&lang=js"
export * from "./OrderAudit.vue?vue&type=script&lang=js"
import style0 from "./OrderAudit.vue?vue&type=style&index=0&id=8534df64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8534df64",
  null
  
)

export default component.exports